import { APP_VERSION_CHANGED, DEVICE_STATUS_CHANGED } from '../actions/types';
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../utils/localStorage';
import * as types from '../actions/types';

const currentAppVersion = LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion);

if (!currentAppVersion) {
    LocalStorage.setItem(LOCAL_STORAGE_KEYS.appVersion, '1');
}

const initialState = {
    appVersion: LocalStorage.getItem(LOCAL_STORAGE_KEYS.appVersion),
    deviceStatus: {
        isOnline: true,
        scanner: true,
        printer: true,
    },
    isBarcodeScanned: false,
    errorModal: {
        isVisible: false,
        errors: [],
    },
    // isBarcodeEntered: false,
};

const global = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case APP_VERSION_CHANGED: {
            return { ...state, appVersion: payload };
        }
        case DEVICE_STATUS_CHANGED: {
            return {
                ...state,
                deviceStatus: {
                    ...state.deviceStatus,
                    ...payload,
                },
            };
        }
        case types.BARCODE_SCANNED: {
            return {
                ...state,
                isBarcodeScanned: payload,
            };
        }
        case types.ERROR_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                errorModal: {
                    ...state.errorModal,
                    ...payload,
                },
            };
        }
        case types.ERROR_MODAL_PROPS_RESET: {
            return {
                ...state,
                errorModal: initialState.errorModal,
            };
        }
        // case types.BARCODE_ENTERED: {
        //     return {
        //         ...state,
        //         isBarcodeEntered: payload,
        //     };
        // }
        default:
            return state;
    }
};

export default global;
